import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';

export default function ConfirmActionDialog({
  open,
  onOpenChange,
  title = 'Confirmar accion',
  description = '',
  confirmText = 'Confirmar',
  confirmLabel,
  cancelText = 'Cancelar',
  onConfirm,
  children,
  confirmDisabled = false,
  // **El rojo tiene que significar algo.** Este boton era rojo **siempre**, incluso para
  // confirmaciones que no destruyen nada —cambiar de plantilla, cambiar el solicitante—. Una
  // confirmacion roja para todo entrena a ignorar el rojo, y entonces el dia que aparece sobre un
  // borrado irreversible no frena a nadie. Por omision sigue siendo rojo: la mayoria de los
  // llamadores de hoy si destruyen, y acertar el default importa mas que la funcion.
  destructivo = true,
}) {
  const label = confirmLabel || confirmText;
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (e) => {
    e.preventDefault();
    if (!onConfirm || loading) return;
    setLoading(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-sm">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-base font-heading">{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {children}
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm" disabled={loading}>{cancelText}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className={destructivo
              ? 'rounded-sm bg-red-600 hover:bg-red-700 text-white'
              : 'rounded-sm bg-brand-primary hover:bg-[#001F6D] text-white'}
            disabled={loading || confirmDisabled}
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : null}
            {label}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
